//@import dependencies
import { combineReducers } from 'redux'
//@end

//@import reducers
import { actionsReducer } from 'app_events/actions/reducers'
import { appReducer } from 'app_events/app/reducers'
import { authReducer } from 'app_events/auth/reducers'
import { coursesReducer } from 'app_events/courses/reducers'
import { LOGOUT } from 'app_events/auth/types'
import { editorReducers } from './editor/reducers';
import { interactionReducer } from './interaction/reducers'
//@end


// @import types
import { IActionState } from './actions/types'
import { IAppState } from './app/types'
import { IUserState } from './auth/types'
import { IStateCourses } from './courses/types'
import { IStateEditor } from './editor/types';
import { IInteractionState } from './interaction/types'
// @end

// @INFO: Interface Combinar reducers
export interface CombinedReducers {
  auth: IUserState
  actions: IActionState
  app: IAppState,
  courses: IStateCourses
  editor: IStateEditor
  interaction: IInteractionState
}

// @INFO: Combinar reducers
const reducers = combineReducers({
  auth: authReducer,
  actions: actionsReducer,
  app: appReducer,
  courses: coursesReducer,
  editor: editorReducers,
  interaction: interactionReducer
})

const rootReducer = (state: any, action: any) => {
  if (action.type === LOGOUT) {
    state = {
      actions: state.actions,
      app: {
        shoppingCart: state?.app?.shoppingCart ?? {action: 'none', data: []}
      }
    }
  }
  return reducers(state, action)
}

export type IRootState = ReturnType<typeof rootReducer>

export default rootReducer
